import { gql } from 'react-apollo';

export const progressDashboard = gql`
  query progressDashboard(
    $masterSubjectId: Int
    $questionType: String
    $sectionIds: [Int]
    $districtId: Int
    $schoolId: Int
    $userStatus: String
    $educationPeriod: Int
  ) {
    progressDashboard(
      masterSubjectId: $masterSubjectId
      questionType: $questionType
      sectionIds: $sectionIds
      districtId: $districtId
      schoolId: $schoolId
      userStatus: $userStatus
      educationPeriod: $educationPeriod
    )
  }
`;

export const studentProgressDashboard = gql`
  query studentProgressDashboard(
    $masterSubjectId: Int
    $questionType: String
    $studentId: String
    $educationPeriod: String
  ) {
    studentProgressDashboard(
      masterSubjectId: $masterSubjectId
      questionType: $questionType
      studentId: $studentId
      educationPeriod: $educationPeriod
    )
  }
`;

export const studentUnitPartScores = gql`
  query studentUnitPartScores(
    $studentId: Int
    $sectionId: Int
    $unitId: Int
    $hasFrq: Boolean
    $masterSubjectId: Int
    $educationPeriod: Int
  ) {
    studentUnitPartScores(
      studentId: $studentId
      sectionId: $sectionId
      unitId: $unitId
      hasFrq: $hasFrq
      masterSubjectId: $masterSubjectId
      educationPeriod: $educationPeriod
    )
  }
`;

export const groupAssignmentScores = gql`
  query groupAssignmentScores(
    $masterSubjectId: Int
    $groupId: Int
    $unitId: Int
    $hasFrq: Boolean
    $userStatus: String
    $educationPeriod: Int
  ) {
    groupAssignmentScores(
      masterSubjectId: $masterSubjectId
      groupId: $groupId
      unitId: $unitId
      hasFrq: $hasFrq
      userStatus: $userStatus
      educationPeriod: $educationPeriod
    )
  }
`;

export const groupAssignmentScoresGroupByAttempt = gql`
  query groupAssignmentScoresGroupByAttempt(
    $masterSubjectId: Int
    $groupId: Int
    $unitId: Int
    $hasFrq: Boolean
    $userStatus: String
    $educationPeriod: Int
  ) {
    groupAssignmentScoresGroupByAttempt(
      masterSubjectId: $masterSubjectId
      groupId: $groupId
      unitId: $unitId
      hasFrq: $hasFrq
      userStatus: $userStatus
      educationPeriod: $educationPeriod
    )
  }
`;

export const curriculumCategories = gql`
  query curriculumCategories($masterSubjectId: Int) {
    curriculumCategories(masterSubjectId: $masterSubjectId) {
      internalName
      id
      title
    }
  }
`;
